/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const pendingSyncStateLastFailureDtoSchema = z.object({
    "at": z.iso.datetime(),
"reason": z.string().nullish()
    })